import {
    attachmentPolicyOf,
    policyEnablesAttachments,
    policyRequiresAtWaitingList,
} from "../../../../Resources/Scripts/_Shared/attachmentPolicy";

export const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
};

export const isWaitingListAttachmentsEnabled = (waitingListFlowContext) => {
    const product = waitingListFlowContext?.product;
    const policy = attachmentPolicyOf(product);
    return policy
        ? policyEnablesAttachments(policy)
        : product?.EnableWaitingListAttachments === true;
};

// Only MANDATORY_AT_WAITING_LIST blocks the join, MANDATORY_BEFORE_ACTIVATION is used later by CSR.
export const isWaitingListAttachmentRequired = (waitingListFlowContext) => {
    if (!isWaitingListAttachmentsEnabled(waitingListFlowContext)) return false;
    const product = waitingListFlowContext?.product;
    const policy = attachmentPolicyOf(product);
    return policy
        ? policyRequiresAtWaitingList(policy)
        : product?.RequireSalesOrderAttachments === true;
};

export const hasWaitingListAttachment = (waitingListFlowContext) =>
    !!waitingListFlowContext?.document?.fileMeta?.uid;

export const base64ToFile = (base64String, fileName, mimeType) => {
    const byteString = atob(base64String.split(",")[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new File([ab], fileName, { type: mimeType });
};

export const base64ToForm = (base64String, fileName, fileType) => {
    const file = base64ToFile(base64String, fileName, fileType);
    const formData = new FormData();
    formData.append("document", file);
    return formData;
};

export const findPlaceById = (data, id) =>
  data.Places
    .flatMap(place => place.Item2)
    .find(item => item.Id === id);

export const minuteToDays = (minutes) => {
  return minutes / (60 * 24);
}
